import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { UserSessionService } from './usersession.service';
import { AuthenticationService } from './authentication.service';
import { AlertService } from './alert.service';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()

export class HttpInterceptorService implements HttpInterceptor {

    private baseUrl = environment.apiBaseUrl;
    excludeLoaderUrls: any[] = ['/api/getStartDate', 'version.json', '/getVersion', '/api/autosearch/address'];

    constructor(
        private router: Router,
        private sessionService: UserSessionService,
        private authService: AuthenticationService,
        private alertService: AlertService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const started = Date.now();

        // add authorization header with jwt token if available
        const authToken = this.sessionService.authToken();

        const weighObj =
            request.headers.get('show-weighobj-error') === 'true';

        if (weighObj) {
            request = request.clone({
                headers: request.headers.delete('show-weighobj-error')
            });
        }

        // Opt a specific request out of the global loader (e.g. background interval polling)
        // without excluding its URL app-wide — set via DataService.post(route, data, headers).
        const isSilentRequest =
            request.headers.get('x-silent-loader') === 'true';

        if (isSilentRequest) {
            request = request.clone({
                headers: request.headers.delete('x-silent-loader')
            });
        }

        const isTokenEndPoint = request.url.match('/api/login');
        if (isTokenEndPoint === null && this.sessionService.userId() && authToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authToken}`,
                }
            });

            // if (request.url.match(environment.vtsBaseUrl)) {
            //     request = request.clone({
            //         setHeaders: {
            //             'X-Auth-Token': environment.xAuthToken
            //         }
            //     });
            // }
        }

        let excludeLoader = isSilentRequest || this.excludeLoaderUrls.some(url => request.url.includes(url))

        if (excludeLoader) {
            document.querySelector('ng-http-loader')?.classList.add('d-none');
        }
        else {
            document.querySelector('ng-http-loader')?.classList.remove('d-none');
        }

        return next.handle(request).pipe(tap((event: any) => {
            if (event instanceof HttpResponse) {
                const action = request.urlWithParams.replace(this.baseUrl, '');
                const elapsed = Date.now() - started;
                console.log(`${action} took ${elapsed} milliseconds`);
            }
        }, (error: any) => {
            if (weighObj) {
                return throwError(error);
            }
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    const isPublicRoute = request.url.includes('/api/scan/dispatch') || request.url.includes('/api/scan/transit') || request.url.includes('/api/getDispatchslipDets') || request.url.includes('/api/getTransitslipDets') || (window.location.hash && (window.location.hash.includes('/public/') || window.location.hash.includes('/transit-details')));
                    if (!isPublicRoute) {
                        this.authService.logOut();
                    }
                    if (error.error && error.error.failures) {
                        this.alertService.error( error.error.failures);
                    } else if (error.error && error.error.value) {
                        const message = error.error.value;
                        this.alertService.error(message);
                    }
                    // this.router.navigate(['/login']);
                } else {
                    this.broadcastFriendlyErrorMessage(error);
                }
            }
            return throwError(error);
        })) as any;
    }

    broadcastFriendlyErrorMessage(rejection) {
        let msg = '';
        if (rejection.status === 0 && (rejection.statusText === '' || rejection.statusText === 'Unknown Error')) {
            this.alertService.error('Unable to connect to the server, please try again in a couple of seconds.');
        } else if (rejection.status === 400) {
            if (rejection.error) {// jshint ignore:line
                msg = (rejection.error.message) ? rejection.error.message : rejection.error; // jshint ignore:line
            }
            this.alertService.error(msg);
        } else if (rejection.status === 404) {
            if (rejection.message) {
                this.alertService.error(rejection.message);
            }
        } else if (rejection.status === 500) {
            if (rejection.error && rejection.error.failures) {
                this.alertService.error(rejection.error.failures);
            } else if (rejection.message) {
                const message = rejection.message;
                this.alertService.error(message);
            }
        } else if (rejection.status === 409) {
            if (rejection.error && rejection.error.Message) {
                this.alertService.error(rejection.error.Message);
            } else if (rejection.message) {
                const message = rejection.message;
                this.alertService.error(message);
            }
        } else if (rejection.responseStatus === 401) {
            
            this.authService.logOut();
            if (rejection.error && rejection.error.Message) {
                this.alertService.error(rejection.error.Message);
            } else if (rejection.message) {
                const message = rejection.message;
                this.alertService.error(message);
            }
            // this.router.navigate(['/login']);
        } else if (rejection.responseStatus === 0) {
            this.alertService.error('Error occured, while uploading file');
        } else if (rejection.responseStatus === 400) {
            if (rejection.response) { // jshint ignore:line
                msg = rejection.response; // jshint ignore:line
            }
            this.alertService.error(msg);
        }
    }
}
